<template>
<v-card flat='flat'>
  <v-toolbar dense flat class='subheading py-2' v-if='withClientName'>
    <v-icon class='mr-2' >account_circle</v-icon>
    {{ formatFullName(client) }}
    <v-spacer></v-spacer>
    <v-btn @click='get' :loading='request.loading' small icon ><v-icon small >replay</v-icon></v-btn>
  </v-toolbar>
  <v-divider v-if='withClientName' ></v-divider>
  <v-progress-linear
    v-if='request.loading'
    indeterminate class='mt-0' :height="2" ></v-progress-linear>
  <v-list v-if='client && client.id' >
    <v-subheader  class='overline' >
      <v-btn small icon
        v-if='!withClientName'
        @click='get' :loading='request.loading' class='pl-0' ><v-icon small >replay</v-icon></v-btn>
      Contact information
      <v-spacer></v-spacer>
      <v-btn
        v-if='relationshipId'
        @click="launchCustomerDetailsDialog(relationshipId, true)" icon >
          <v-icon >edit</v-icon>
      </v-btn>
    </v-subheader>
    <v-list-tile >
      <v-list-tile-avatar><v-icon>phone</v-icon></v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-if='client.phone_number' >{{ client.phone_number }}</v-list-tile-title>
        <v-list-tile-title v-else >No phone number</v-list-tile-title>
        <v-list-tile-sub-title>Contact number</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile >
      <v-list-tile-avatar><v-icon>mail</v-icon></v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-if='isRealEmail(client.email)' >{{ client.email }}</v-list-tile-title>
        <v-list-tile-title v-else >No e-mail address</v-list-tile-title>
        <v-list-tile-sub-title>E-mail address</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>

  <v-list three-line dense subheader v-if='record && record.id' >
    <template v-if="record.medical_aid" >
      <v-divider class='mt-3'></v-divider>
      <v-subheader class='overline' >Medical aid details
        <v-spacer></v-spacer>
        <v-btn
          v-if='relationshipId'
          @click="launchCustomerDetailsDialog(relationshipId, true, 1)" icon >
            <v-icon >edit</v-icon>
        </v-btn>
      </v-subheader>
      <v-list-tile >
        <v-list-tile-content>
          <v-list-tile-title>{{ record.medical_aid.name || 'n/a' }}</v-list-tile-title>
          <v-list-tile-sub-title v-if='record.medical_aid.scheme' class="text--primary" >
            {{ record.medical_aid.scheme }}
          </v-list-tile-sub-title>
          <v-list-tile-sub-title ># {{ record.medical_aid.number || 'no membership number' }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile >
        <v-list-tile-content>
          <v-list-tile-title class='overline' >Patient</v-list-tile-title>
          <v-list-tile-title class="text--primary" >
            {{ record.medical_aid.patient_first_name }} {{ record.medical_aid.patient_last_name}}
          </v-list-tile-title>
          <v-list-tile-sub-title >ID: {{ record.medical_aid.patient_id_number || 'unknown' }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile v-if="record.medical_aid.is_dependent === true" >
        <v-list-tile-content>
          <v-list-tile-title class='overline' >Main member</v-list-tile-title>
          <v-list-tile-sub-title class="text--primary">{{ record.medical_aid.member_first_name }} {{ record.medical_aid.member_last_name }}</v-list-tile-sub-title>
          <v-list-tile-sub-title >ID: {{ record.medical_aid.member_id_number || 'unknown' }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
    <v-divider></v-divider>
    <v-subheader class='overline' >
      Invoice information
      <v-spacer></v-spacer>
      <!-- $store.getters.me.id -->
      <v-btn
        v-if='relationshipId'
        @click="launchCustomerDetailsDialog(relationshipId, true, 2)" icon >
          <v-icon >edit</v-icon>
      </v-btn>
    </v-subheader>
    <template v-if='record.patient' >
      <v-list-tile >
        <v-list-tile-content>
          <v-list-tile-sub-title>Billing address</v-list-tile-sub-title>
          <v-list-tile-sub-title class="text--primary">
            <pre style='font-family: Roboto,sans-serif;'>{{ record.patient.billing_address || 'Unknown. We\'ll use contact details above' }}
            </pre>
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
  </v-list>
  <v-alert class='mb-0' type='warning' :value='request.status > 299' >
    Unable to load client record
    <v-btn flat @click="get" >Try again</v-btn>
  </v-alert>
</v-card>
</template>

<script>

export default {
  name: 'ClientCard',
  props: {
    relationshipId: { required: true },
    initialData: { type: Object, required: false },
    touch: { type: Number, required: false, default: 0 },
    flat: { type: Boolean, default: false },
    withClientName: { type: Boolean, default: true }
  },
  data () {
    return {
      request: {
        resource: 'ag.spaces.relationships',
        loading: false
      }
    }
  },
  watch: {
    relationshipId () {
      this.get()
    },
    record () {
      this.$emit('record', this.record)
    },
    relationship () {
      this.$emit('relationship', this.relationship)
    }
  },
  mounted () {
    this.get()
  },
  computed: {
    relationship () {
      if (this.relationshipId) {
        return this.$store.getters.getClientDetailByRelationshipId(this.relationshipId)
      }
      return {}
    },
    client () {
      if (this.relationship) {
        let relationshipListView = this.$store.getters.getClientByRelationshipId(this.relationshipId)
        if (relationshipListView && relationshipListView.client) {
          return relationshipListView.client
        }
      }
    },
    record () {
      if (this.relationship) {
        return this.relationship.record
      }
    }
  },
  methods: {
    get () {
      if (this.relationshipId) {
        this.request.resourceId = this.relationshipId
        this.$request('get', this.request)
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ClientCard.vue?01eb2af8